import { callGetApi, callPostApi } from "../interceptor";

// Get Wallet Transactions List API function
export async function getWalletTransactions(data) {
  try {
    const response = await callPostApi({
      url: `wallet-transactions/transactions`,
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get Card Transactions List API function
export async function getCardTransactions(data) {
  try {
    const response = await callPostApi({
      url: `transactions/card-transactions`,
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
